/**
 * com.remedirx.apps.MyRemedi
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { Filter } from './filter';
import { Sort } from './sort';


/**
 * Data transfer object used to communicate changes in filters, sorts, search terms, and pages
 */
export interface SortFilterDto { 
    Filters?: Array<Filter>;
    Sorts?: Array<Sort>;
    SearchTerm?: string;
    PageNumber?: number;
    PageSize?: number;
    FilterType?: SortFilterDto.FilterTypeEnum;
}
export namespace SortFilterDto {
    export type FilterTypeEnum = 'And' | 'Or';
    export const FilterTypeEnum = {
        And: 'And' as FilterTypeEnum,
        Or: 'Or' as FilterTypeEnum
    };
}
